import { render, staticRenderFns } from "./HighlightControl.vue?vue&type=template&id=13a1a06a"
import script from "./HighlightControl.vue?vue&type=script&lang=js"
export * from "./HighlightControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports